import axios from 'axios';
import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { baseUrl } from '../../baseUrl';
import parse from 'html-react-parser';
import moment from 'moment';
import { MagnifyingGlass } from 'react-loader-spinner';

const Blog = () => {
    const [blog, setBlog] = useState(null)
    const { id } = useParams();
    const [loading, setLoading] = useState(true);

    const getBlog = async () => {
        try {
            const response = await axios.get(`${baseUrl}/blog/${id}`);
            setBlog(response.data);
        } catch (error) {
            console.error('Error fetching blog:', error?.response?.data?.message || error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id) getBlog();
    }, [id])

    return (
        <div className='container'>
            <style dangerouslySetInnerHTML={{ __html: globalStyles }} />
            <div className='row mb-3'>
                {
                    loading ?
                        <MagnifyingGlass
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="magnifying-glass-loading"
                            wrapperStyle={{}}
                            wrapperClass="magnifying-glass-wrapper"
                            glassColor="#c0efff"
                            color="#8000df"
                        /> :
                        <div className="col-lg-12">
                            <div className="post-single">
                                <div className="post-thumb d-flex justify-content-center">
                                    <img src={`${process.env.REACT_APP_API_URL}${blog.imageUrl}`} alt="" className="img-fluid" />
                                </div>
                                <div className="single-post-content">
                                    <div className="post-meta mt-4">
                                        <span className="post-date"><i className="fa fa-calendar-alt mr-2"></i>{moment(blog.createdAt).format('DD MMM YYYY')}</span>
                                        <span><Link className="post-author"><i className="fa fa-user mr-2"></i>Monarch Institute</Link></span>
                                    </div>
                                    <h2>{blog.title}</h2>
                                    <div>{parse(blog.detail)}</div>
                                </div>
                            </div>
                        </div>
                }
            </div>
        </div>
    )
}

const globalStyles = `
        table, th, td ,tr{
            border: 1px solid black!important;
        }
            table tr td{
            border-top: 1px solid black!important}
        th, td {
        padding:3px!important;
            text-align: center;
        }
        ul {
        list-style:disc;
        }
        ul li{
        margin-left:10px
        }
    `;

export default Blog
